import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Table, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

const RealisationNotesTableModal = ({ open, onClose, notes }: any) => {
	const filteredNotes = notes.filter((n: any) => n.name && n.name.trim() !== '');

	return (
		<Dialog open={open} onClose={onClose} maxWidth='md' fullWidth>
			<DialogTitle>
				<span className='text-[#04438b] text-2xl font-bold'>Све напомене по кварталима</span>
			</DialogTitle>

			<DialogContent>
				<Table>
					<TableHead>
						<TableRow>
							<TableCell>Ред. број</TableCell>
							<TableCell>Напомена</TableCell>
							<TableCell>Квартал</TableCell>
						</TableRow>
					</TableHead>

					<TableBody>
						{filteredNotes?.length > 0 ? (
							filteredNotes.map((n: any, idx: number) => (
								<TableRow key={n.id}>
									<TableCell>{idx + 1}</TableCell>
									<TableCell>{n.name}</TableCell>
									<TableCell>{n.quarter}</TableCell>
								</TableRow>
							))
						) : (
							<TableRow>
								<TableCell colSpan={3} style={{ textAlign: 'center', padding: 20 }}>
									Нема унетих напомена.
								</TableCell>
							</TableRow>
						)}
					</TableBody>
				</Table>
			</DialogContent>

			<DialogActions>
				<Button onClick={onClose} variant='contained' sx={{ backgroundColor: '#0F2765' }}>
					Затвори
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default RealisationNotesTableModal;
